// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3b-1";
export var movingGradient = "_3b-4";
export var movingGradientBlock = "_3b-2";
export var skeleton = "_3b-0";
export var skeletonText = "_3b-3";